import { DictionaryModel, DictionarySet } from "@core/models/dictionary.model";
import { ShipmentTaskDTO } from "@core/models/planner-models/shipment-task.dto";

export interface ShipmentTaskModel extends ShipmentTaskDTO {
    TaskType: DictionaryModel;
    Categories: DictionaryModel[];
    WasteCodes: DictionaryModel[];


    CarrierNormalized: string;
    PointNameNormalized: string;
    AddressNormalized: string;
    BDONormalized: string;
    DriverNameNormalized: string;
    DriverPhoneNormalized: string;
    VehicleNumberNormalized: string;
    TrailerNumberNormalized: string;
    NoteCargoNormalized: string;
}

export function mapShipmentTaskDtoToModel(dto: ShipmentTaskDTO, taskTypesDictionary: DictionarySet, vehicleCategorySet: DictionarySet, wasteCodesSet: DictionarySet,): ShipmentTaskModel {
    return {
        ...dto,
        TaskType: taskTypesDictionary[dto.TaskTypeId],
        Categories: !dto.CategoryIds ? [] : dto.CategoryIds.split('|').filter(c => c.length > 0).map(c => vehicleCategorySet[Number.parseInt(c)]),
        WasteCodes: !dto.WasteCodeIds ? [] : dto.WasteCodeIds.split('|').filter(c => c.length > 0).map(c => wasteCodesSet[Number.parseInt(c)]),
        RealPlanDateMin: new Date(dto.RealPlanDateMin),

        CarrierNormalized: dto.Carrier?.toLocaleLowerCase() || '',
        PointNameNormalized: dto.PointName?.toLocaleLowerCase() || '',
        AddressNormalized: dto.Address?.toLocaleLowerCase() || '',
        BDONormalized: dto.BDO?.toLocaleLowerCase() || '',
        DriverNameNormalized: dto.DriverName?.toLocaleLowerCase() || '',
        DriverPhoneNormalized: dto.DriverPhone?.toLocaleLowerCase() || '',
        VehicleNumberNormalized: dto.VehicleNumber?.toLocaleLowerCase() || '',
        TrailerNumberNormalized: dto.TrailerNumber?.toLocaleLowerCase() || '',
        NoteCargoNormalized: dto.NoteCargo?.toLocaleLowerCase() || '',
    }
}